import type { enDapur } from '../en/dapur';

export const idDapur: Record<keyof typeof enDapur, string> = {
  'kds.nav.tickets': 'Tiket',
  'kds.nav.menu': 'Menu',
  'kds.page.subtitle': 'Tiket per stasiun, yang terlama di depan.',
  // ---- Header -------------------------------------------------------------------------
  'kds.clock.label': 'Waktu cabang · {zone}',
  'kds.fullscreen.enter': 'Masuk layar penuh',
  'kds.fullscreen.exit': 'Keluar dari layar penuh',
  'kds.settings.open': 'Pengaturan layar dapur',
  'kds.settings.title': 'Pengaturan layar dapur',
  'kds.settings.description': 'Hanya disimpan di perangkat ini.',
  'kds.settings.threshold.label': 'Terlambat setelah (menit)',
  'kds.settings.threshold.hint':
    'Bilangan bulat dari {min} sampai {max} menit. Label "Segera" muncul mulai 75% dari waktu ini.',
  'kds.settings.threshold.invalid': 'Masukkan bilangan bulat dari {min} sampai {max}.',

  // ---- Board ----------------------------------------------------------------------------
  'kds.stations.label': 'Stasiun dapur',
  'kds.stations.all': 'Semua',
  'kds.stations.loadFailed': 'Stasiun tidak dapat dimuat — menampilkan semua stasiun.',
  'kds.board.title': 'Tiket aktif',
  'kds.board.description': 'Terlama di depan. Terlambat setelah {minutes} menit.',
  'kds.board.count': 'Sedang diproses: {count}',
  'kds.board.empty':
    'Belum ada tiket aktif — tiket muncul saat pelayan atau kasir mengirim pesanan ke dapur.',
  'kds.board.emptyStation':
    'Belum ada tiket aktif untuk {station} — tiket muncul saat pelayan atau kasir mengirim pesanan ke dapur.',
  'kds.recent.title': 'Siap & terbaru',
  'kds.recent.description': 'Tiket siap, disajikan, dan dibatalkan dalam 3 jam terakhir.',
  'kds.recent.empty': 'Belum ada yang siap — tiket pindah ke sini setelah ditandai siap.',
  'kds.recent.readyAt': 'Siap pukul {time}',
  'kds.recent.servedAt': 'Disajikan pukul {time}',
  'kds.recent.sentAt': 'Dikirim pukul {time}',
  'kds.recent.prepTime': 'Disiapkan dalam {time}',

  // ---- Ticket card ----------------------------------------------------------------------
  'kds.ticket.order': 'Pesanan {number}',
  'kds.ticket.number': 'Tiket {number}',
  'kds.ticket.submission': 'Kiriman ke-{number}',
  'kds.ticket.station': 'Stasiun: {name}',
  'kds.ticket.elapsedLabel': 'Menunggu',
  'kds.ticket.elapsedAria': 'Menunggu {time} sejak dikirim',
  'kds.urgency.overdue': 'Terlambat',
  'kds.urgency.soon': 'Segera',
  'kds.item.quantity': '{count}×',
  'kds.item.seat': 'Kursi {seat}',
  'kds.item.note': 'Catatan',
  'kds.item.cancelled': 'Dibatalkan',
  'kds.item.cancelReason': 'Alasan: {reason}',
  'kds.action.acknowledge': 'Terima',
  'kds.action.start': 'Mulai masak',
  'kds.action.ready': 'Siap',
  'kds.action.saving': 'Menyimpan…',
  'kds.toast.conflict':
    'Tiket {ticket} ({table}) sudah diubah di perangkat lain. Versi terbaru sekarang ditampilkan.',
  'kds.nav.requests': 'Permintaan',
};
